import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useApiQuery from 'lib/api/useApiQuery';
import { currencyUnits } from 'lib/units';
import { Button } from 'toolkit/chakra/button';
import CurrencyValue from 'ui/shared/CurrencyValue';
import NativeTokenIcon from 'ui/shared/NativeTokenIcon';

interface Props {
  address: string;
}

const UserWalletBalance = ({ address }: Props) => {
  const { data, isLoading } = useApiQuery('general:address', {
    pathParams: { hash: address },
    queryOptions: {
      enabled: Boolean(address),
    },
  });

  if (!data && !isLoading) {
    return null;
  }

  return (
    <Flex direction="column" gap={ 1 } mb={ 4 }>
      <Text fontSize="xs" color="whiteAlpha.600" fontWeight={ 500 }>
        Balance
      </Text>
      <CurrencyValue
        value={ data?.coin_balance || '0' }
        exchangeRate={ data?.exchange_rate }
        decimals={ String(config.chain.currency.decimals) }
        currency={ config.chain.currency.symbol }
        accuracyUsd={ 2 }
        accuracy={ 5 }
        flexWrap="wrap"
        alignItems="center"
        rowGap={ 0 }
        isLoading={ isLoading }
        startElement={ <NativeTokenIcon boxSize={ 4 } isLoading={ isLoading }/> }
        fontWeight={ 600 }
        fontSize="sm"
      />
    </Flex>
  );
};

export default React.memo(UserWalletBalance);
